import { getRoninProgress, saveRoninProgress, getRoninLeaderboard } from '../api/hrmApi';

export function attachRoninCloudBridge({ frame, iframe, onExpired, isActive = () => true }) {
  const controller = new AbortController();
  const origin = new URL(frame.pageUrl, window.location.href).origin;
  const pending = new Set();
  const receive = async (event) => {
    const data = event.data;
    if (!isActive() || event.source !== iframe?.contentWindow || event.origin !== origin ||
        data?.type !== 'antrazal:ronin:cloud-request' || data.playerKey !== frame.playerKey ||
        data.version !== frame.version || typeof data.id !== 'string' || !/^[a-z0-9-]{1,64}$/.test(data.id) ||
        !['load', 'save', 'leaderboard'].includes(data.action) || pending.has(data.id) || pending.size >= 3) return;
    pending.add(data.id);
    const reply = { type: 'antrazal:ronin:cloud-response', id: data.id, playerKey: frame.playerKey, version: frame.version };
    try {
      const options = { signal: controller.signal, playerKey: frame.playerKey };
      const result = data.action === 'load' ? await getRoninProgress(options) : data.action === 'leaderboard'
        ? await getRoninLeaderboard(options) : await saveRoninProgress(data.payload, options);
      if (result?.success !== true || !result.data) throw new Error('Cloud response was not valid.');
      reply.data = result.data;
    } catch (error) {
      if (error.status === 401 || error.status === 403) onExpired();
      reply.error = { status: error.status || 503, message: error.message || 'Cloud service unavailable.' };
    } finally {
      pending.delete(data.id);
    }
    if (!controller.signal.aborted && isActive()) event.source.postMessage(reply, origin);
  };
  window.addEventListener('message', receive);
  return () => { controller.abort(); window.removeEventListener('message', receive); };
}
